import PCUI from './component/index';
import H5UI from './H5component/index';
import { isMobile, deepAssign } from './common/Utils';
import getLang from './common/lang/index';
import { Promise } from 'es6-promise';
import DanmakuSetting from './component/danmakuSetting/index.js';

export default class VhallInterface {
  constructor(param) {
    this._api = param.api;
    this._originalOption = {};
    this.store = param.store;
    this.language = getLang(param.store);
    this.__UIControl = {};
    this.vhallplayer = param.vhallplayer; // VideoModule实例
    this.isLive = param.isLive;
    this.markPoints = param.markPoints;
    this.markPointsConfig = param.markPointsConfig;
    this.aiHightlights =  param.aiHightlights;
    this.barrageSetting = param.barrageSetting;
    this.videoNode = param.videoNode;
    this.isLimitSeek = false; // 是否开启seek限制
    this.limitSeekMax = 0; // seek限制的最大值
    this.vhallplayer.on('seeked', res => {
      if (this.isLimitSeek) {
        const seekMax =
          this.vhallplayer.getPlayed().length >= 1
            ? Math.max(this.limitSeekMax, this.vhallplayer.getPlayed().end(this.vhallplayer.getPlayed().length - 1))
            : this.isLimitSeek; // seek的最大限制
        if (this.vhallplayer.getCurrentTime() > seekMax) {
          this.vhallplayer.setCurrentTime(seekMax);
        }
      }
    });

    //初始化播放器各个元素控件
    this.isMobile = isMobile();
    if (!this.isMobile) {
      /* eslint-disable no-new */
      let UIComponent = new PCUI(this.videoNode, this, param.markPoints, param.aiHightlights);
      this._UIComponent = UIComponent;
    } else {
      /* eslint-disable no-new */
      let UIComponent = new H5UI(this.videoNode, this, param.markPoints, param.aiHightlights);
      this._UIComponent = UIComponent;
    }

    this.barrageSetting.enable ? this.openBarrage() : this.closeBarrage();
  }

  /**
   * 销毁当前实例
   */
  destroy() {
    VhallMsg.emitBroadcast({ type: 'delay', data: { delay: -1 } });
    this.vhallplayer.destroy();

    let videoBox = document.querySelector(this.videoNode);
    if (videoBox) {
      // PC端控制条 下
      const container = videoBox.querySelector('.vhallPlayer-container');
      // PC端控制条 light  上
      const pccontainerup = videoBox.querySelector('.vhallPlayer-container-up');

      // 移动端控制条 下
      const shadow = videoBox.querySelector('.vhallPlayerh5-shadow');
      // 移动端中心播放按钮
      const playBtn = videoBox.querySelector('.vh-playBtnContainer');

      // 移动端控制条 light 上
      const containerup = videoBox.querySelector('.h5vhallPlayer-container-up');
      // 移动端清晰度弹窗 light
      const definitionpopup = videoBox.querySelector('.h5definition-popup');

      const danmakuBox = videoBox.querySelector('#vhy-danmaku-wrapbox');
      const watermarkBox = videoBox.querySelector('#vh-watermark-container');

      const subtitleTip = videoBox.querySelector('#vh-subtitleTip-close-subtitle');

      subtitleTip && subtitleTip.parentNode.removeChild(subtitleTip);

      container && container.parentNode.removeChild(container);
      pccontainerup && pccontainerup.parentNode.removeChild(pccontainerup);
      shadow && shadow.parentNode.removeChild(shadow);
      playBtn && playBtn.parentNode.removeChild(playBtn);
      containerup && containerup.parentNode.removeChild(containerup);
      definitionpopup && definitionpopup.parentNode.removeChild(definitionpopup);
      danmakuBox && danmakuBox.parentNode.removeChild(danmakuBox);
      watermarkBox && watermarkBox.parentNode.removeChild(watermarkBox);
    }
  }

  /**
   * 打开或关闭UI（未暴露官方文档）
   * @param {boolean} boolean 开启或关闭UI
   */
  openUI(boolean) {
    const _isMobile = isMobile();
    const UI = _isMobile
      ? document.querySelector('.vhallPlayerh5-shadow')
      : document.querySelector('.vhallPlayer-container');
    boolean ? UI.classList.remove('close') : UI.classList.add('close');
    if (_isMobile) {
      const playBtn = document.querySelector('.vh-playBtnContainer');
      boolean ? playBtn && playBtn.classList.remove('close') : playBtn && playBtn.classList.add('close');
    }
  }

  /**
   * 事件监听。通过VideoModule实例监听
   * @param {string} eventName 事件名
   * @param {function} handler 处理函数
   */
  on(eventName, handler) {
    this.vhallplayer.on(eventName, handler);
  }

  /**
   * 移除事件监听
   * @param {string} eventName 事件名
   * @param {function} handler 处理函数
   */
  off(eventName, handler) {
    this.vhallplayer.off(eventName, handler);
  }

  /**
   * 获取回放文档cuepoint数据
   */
  getCuepointData() {
    if (!this.isLive) {
      // 派发cue_point事件，以兼容同步加载情况下的历史用法
      window.VhallMsg && VhallMsg.emitBroadcast({ type: 'cue_point', data: this.store.getKV('cuepoint') });
      // 返回数据
      return this.store.getKV('cuepoint');
    } else {
      return '';
    }
  }

  /**
   * 播放
   */
  refreshDispatch() {
    return this.vhallplayer.refreshDispatch();
  }

  /**
   * 播放
   */
  play() {
    return this.vhallplayer.play();
  }

  /**
   * 暂停
   */
  pause() {
    this.vhallplayer.pause();
  }

  /**
   * 获取当前暂停状态
   */
  getIsPause() {
    return this.vhallplayer.getIsPaused();
  }

  /**
   * 获取循环状态（仅点播）
   * @param {function} failure 失败回调
   */
  getLoop(failure) {
    if (this.isLive) {
      failure && failure({ code: '611004', message: '此方法仅点播可用', data: {} });
      return;
    }
    return this.vhallplayer.getLoop();
  }

  /**
   * 设置循环（仅点播）
   * @param {boolean} isLoop 是否循环
   * @param {function} failure 失败回调
   */
  setLoop(isLoop, failure) {
    if (this.isLive) {
      failure && failure({ code: '611004', message: '此方法仅点播可用', data: {} });
      return;
    }
    if (typeof isLoop !== 'boolean') {
      failure && failure({ code: '611001', message: '无效的参数', data: {} });
      return;
    }
    this.vhallplayer.setLoop(isLoop);
  }

  /**
   * 获取视频清晰度列表
   * @return {Array} 视频清晰度
   */
  getQualitys() {
    return this.vhallplayer.currentDefinitionList || [];
  }

  /**
   * 获取当前视频清晰度
   */
  getCurrentQuality() {
    return this.vhallplayer.currentDefinition || {};
  }

  /**
   * 设置当前视频清晰度
   * @param {object} obj 清晰度对象
   * @param {function} failure 失败回调
   */
  setQuality(obj, failure) {
    if (Object.prototype.toString.call(obj) !== '[object Object]') {
      failure && failure({ code: '611001', message: '无效的参数', data: {} });
      return Promise.reject(new Error('无效的参数'));
    }
    // 由于底层内核SDK删除了判断切线地址是否为当前地址的逻辑，故在此添加
    if (this.vhallplayer.currentDefinition && this.vhallplayer.currentDefinition.url === obj.url)
      return Promise.reject(new Error('新旧清晰度相同, 不进行切换'));
    // this.vhallplayer.currentDefinition = obj; 2020 - 11 -13前，均通过该方式切线，为了准确返回切线状态
    if (
      this.vhallplayer._config &&
      this.vhallplayer._config.x5 &&
      this.vhallplayer.player &&
      this.vhallplayer.player._type !== 'NativePlayer' &&
      this.vhallplayer.isFullscreen
    ) {
      // 退出全屏后不能马上切线，不然还是无法进入全屏。。。
      // this.vhallplayer.exitFullscreen();
      setTimeout(() => {
        return this.vhallplayer.setQuality(obj);
      }, 0);
    } else {
      return this.vhallplayer.setQuality(obj);
    }
  }

  /**
   * 进入全屏
   * @param {function} failure 失败回调
   */
  enterFullScreen(failure) {
    if (this.vhallplayer.isFullscreen) {
      failure && failure({ code: '611005', message: '进入全屏失败', data: {} });
      return;
    }
    this.vhallplayer.enterFullscreen();
    try {
      this.vhallplayer.clearBarrage();
    } catch (e) {}
  }

  /**
   * 退出全屏
   * @param {function} failure 失败回调
   */
  exitFullScreen(failure = () => {}) {
    // if (!this.vhallplayer.isFullscreen) {
    //   failure && failure({ code: '611006', message: "退出全屏失败", data: {} });
    //   return;
    // }
    this.vhallplayer._clickExit = true;

    try {
      this.vhallplayer.clearBarrage();
    } catch (e) {}

    this.vhallplayer.exitFullscreen();
  }

  /**
   * 获取当前是否是全屏
   */
  isFullscreen() {
    return this.vhallplayer.isFullscreen;
  }

  /**
   * 获取音量
   */
  getmute() {
    return this.vhallplayer.getMuted();
  }
  /**
   * 设置静音
   * @param {boolean} isMute 是否静音
   * @param {function} failure 失败回调
   */
  setMute(isMute, failure) {
    if (typeof isMute !== 'boolean') {
      failure && failure({ code: '611001', message: '无效的参数', data: {} });
      return;
    }
    this.vhallplayer.setMuted(isMute);
  }

  /**
   * 获取音量
   */
  getVolume() {
    return this.vhallplayer.getVolume() * 100;
  }
  /**
   * 设置音量
   * @param {int} volume 音量 0~100
   * @param {function} failure 失败回调
   */
  setVolume(vol, failure) {
    if (typeof vol !== 'number') {
      failure && failure({ code: '611001', message: '无效的参数', data: {} });
      return;
    }
    if (vol < 0 || vol > 100) {
      failure && failure({ code: '611001', message: '无效的参数', data: {} });
      return;
    }
    this.vhallplayer.setVolume(vol / 100);
  }

  /**
   * 获取当前视频总时长（仅点播）
   * @param {function} failure 失败回调
   */
  getDuration(failure) {
    if (this.isLive) {
      failure && failure({ code: '611004', message: '此方法仅点播可用', data: {} });
      return;
    }
    return this.vhallplayer.getDuration();
  }

  /**
   * 获取当前视频播放时间（仅点播、直播时移）
   * @param {function} failure 失败回调
   */
  getCurrentTime(failure) {
    if (
      this.isLive &&
      (!this.vhallplayer._config.isOpenTimeshift ||
        (this.vhallplayer._config.isOpenTimeshift && this.vhallplayer._config.type !== 'hls'))
    ) {
      failure &&
        failure({
          code: '611004',
          message: '此方法仅时移直播和点播可用',
          data: {}
        });
      return;
    }
    return this.vhallplayer.getCurrentTime();
  }

  /**
   * 设置当前播放时间（仅点播）
   * @param {int} time 单位秒
   * @param {function} failure 失败回调
   */
  setCurrentTime(time, failure = () => {}) {
    if (this.isLive) {
      failure && failure({ code: '611004', message: '此方法仅点播可用', data: {} });
      return;
    }
    if (typeof time !== 'number') {
      failure && failure({ code: '611001', message: '无效的参数', data: {} });
      return;
    }
    clearTimeout(this.timerId);
    // 频繁seek时，最后一次seek后会卡顿切线, 延迟seek
    if (this.vhallplayer.getSeeking()) {
      this.timerId = setTimeout(() => {
        this.vhallplayer.setCurrentTime(time || 0);
      }, 200);
      return;
    }
    this.vhallplayer.setCurrentTime(time || 0);
  }

  /**
   * 获取当前网络状态
   * @return {int} 0:音频/视频尚未初始化,1:音频/视频是活动的且已选取资源，但并未使用网络,2:浏览器正在下载数据,3:未找到音频/视频来源
   */
  getNetworkState() {
    return this.vhallplayer.getNetworkState();
  }

  /**
   * 获取当前可选倍速
   * @return {object} 可选倍速
   * @param {function} failure 失败回调
   */
  getUsableSpeed(failure) {
    if (this.isLive) {
      failure && failure({ code: '611004', message: '此方法仅点播可用', data: {} });
      return;
    }
    return this.vhallplayer.playbackRateList;
  }

  /**
   * 设置倍速播放
   * @param {string} speed 倍速值
   * @param {function} failure 失败回调
   */
  setPlaySpeed(speed, failure) {
    if (this.isLive) {
      failure && failure({ code: '611004', message: '此方法仅点播可用', data: {} });
      return;
    }
    const playbackRateList = this.vhallplayer.playbackRateList;
    if (typeof speed !== 'number') {
      failure && failure({ code: '611001', message: '无效的参数', data: {} });
      return;
    }

    if (playbackRateList.indexOf(speed) === -1) {
      failure && failure({ code: '611001', message: '无效的参数', data: {} });
      return;
    }
    this.vhallplayer.setPlaybackRate(speed);
  }

  /**
   * 视频截图
   */
  videoScreenshot() {
    return this.vhallplayer.capture();
  }

  /**
   * 获取弹幕开启状态（未暴露文档）
   */
  barrageState() {
    return this.vhallplayer.barrageState();
  }

  /**
   * 开启弹幕
   */
  openBarrage() {
    this.vhallplayer.openBarrage();
    this.barrageSetting.enable = true;
    this.__UIControl.updateBarrageUI({ enable: true });
    this.saveSetting();
  }

  /**
   * 关闭弹幕
   */
  closeBarrage() {
    this.vhallplayer.closeBarrage();
    this.barrageSetting.enable = false;
    this.__UIControl.updateBarrageUI({ enable: false });
    this.saveSetting();
  }

  /**
   * 清空弹幕
   */
  clearBarrage() {
    this.vhallplayer.clearBarrage();
  }

  /**
   * 获取弹幕帧率
   * @return {string} 帧率
   */
  getBarrageFPS() {
    return this.vhallplayer.barrageFPS;
  }

  /**
   * 添加弹幕
   * @param {string} content 弹幕内容
   * @param {Object} setting 弹幕设置
   * @param {function} failure 失败回调
   */
  addBarrage(content, setting, failure) {
    const reg = /<(?!img).*?>/gi;
    content = content.replace(reg, '');
    let cache = content.replace(/<(img).*?>/gi, '');
    let fail = null;
    if (setting && typeof setting === 'function') {
      fail = setting;
    }
    if (failure) {
      fail = failure;
    }
    // 增加 弹幕配置参数
    if (!content) {
      fail && fail({ code: '611001', message: '弹幕内容不能为空', data: {} });
      return;
    }
    if (cache.length > 150) {
      fail &&
        fail({
          code: '611001',
          message: '弹幕内容长度不能超过150个字',
          data: {}
        });
      return;
    }

    if (setting && typeof setting !== 'function') {
      let success = true;
      Object.keys(setting).forEach(key => {
        if (!setting[key]) {
          success = false;
        }
      });
      if (!success) {
        fail && fail({ code: '611001', message: '弹幕样式参数不合法', data: {} });
        return;
      }

      // 没有传h5FontSize则取 fontSize的值
      if (setting.fontSize && !setting.h5FontSize) {
        setting.h5FontSize = setting.fontSize;
      }

      let fontSize = isMobile() ? setting.h5FontSize : setting.fontSize;
      let unit = (isMobile() ? setting.h5Unit : setting.unit) || 'px';

      if (fontSize && unit === 'px' && (fontSize > 50 || fontSize < 12)) {
        fail &&
          fail({
            code: '611001',
            message: '弹幕样式字体大小，最大为50最小为12',
            data: {}
          });
        return;
      }
    }

    this.vhallplayer.addBarrage(content, setting);
  }

  /**
   * 设置弹幕信息
   * @param {object} opt 设置弹幕配置 {position:(0|1|2|3)  上 中 下 全屏 , alpha:(0~1) , fontsize:(int) , color:(#ffffff) }
   */
  setBarrageInfo(opt, failure) {
    // To do
    // change this function
    // if (typeof opt !== "object" && (!opt.hasOwnProperty('position') || !opt.hasOwnProperty('alpha') || !opt.hasOwnProperty('fontsize') || !opt.hasOwnProperty('color'))) {
    //   failure && failure({ code: '611001', message: "无效的参数", data: {} });
    //   return;
    // }
    // const { position, alpha, fontsize, color } = opt;
    // typeof position === "number" && (this.vhallplayer.barragePosition = position);
    // alpha && (this.vhallplayer.barrageAlpha = alpha);
    // fontsize && (this.vhallplayer.barrageFontsize = fontsize);
    // color && (this.vhallplayer.barrageColor = color);

    if (typeof opt !== 'object') {
      failure && failure({ code: '611001', message: '无效的参数', data: {} });
      return Promise.reject(new Error({ code: '611001', message: '无效的参数', data: {} }));
    }

    // duration: 12, // 完成基准，基于这个时间进行下浮动,取值范围为：(Math.random() * duration / 3)>>>0
    // position: 3, // 0:top,距离上10%~~50%, 1：middle,30%~70%， 2：bottom,50%~90% 3:all,距离上下各10% -- 旧参数
    // fontsize: 18, // 旧参数 - 兼容处理一下
    // alpha: 0.8,
    // font: 'Microsoft YaHei',
    // color: '#FFF',
    if (opt.position) {
      switch (~opt.position) {
        case 0:
          opt.positionRange = [0.1, 0.5];
          break;
        case 1:
          opt.positionRange = [0.3, 0.7];
          break;
        case 2:
          opt.positionRange = [0.5, 0.9];
          break;
        case 3:
          opt.positionRange = [0.1, 0.9];
          break;
        default:
          opt.positionRange = [0.1, 0.5];
          break;
      }
    }

    if (opt.fontsize) {
      if (!opt.style) opt.style = {};
      opt.style.fontSize = opt.fontsize;
      opt.style.unit = opt.unit;
    }
    if (opt.alpha) {
      if (!opt.style) opt.style = {};
      opt.style.opacity = opt.alpha;
    }

    if (opt.font) {
      if (!opt.style) opt.style = {};
      opt.style.fontFamily = opt.font;
    }

    if (opt.color) {
      if (!opt.style) opt.style = {};
      opt.style.color = opt.color;
    }

    deepAssign(this.barrageSetting, opt);
    this.vhallplayer.setBarrageInfo(this.barrageSetting);
    this.__UIControl.updateBarrageUI(this.barrageSetting);
    this.saveSetting();
    this.vhallplayer.emit2All(VhallPlayer.DANMAKU_SETTING_CHANGE, this.barrageSetting);
  }

  // 加载自定义弹幕设置面板
  loadCustomDanmakuSettingPopup() {
    // 自定义容器有时候是懒加载，业务侧在点击时再加载，需要调用此方法
    if (this.barrageSetting.popupContainer) {
      // 找到自定义的面板容器
      const popup = document.querySelector(this.barrageSetting.popupContainer);
      if (popup) {
        new DanmakuSetting(popup, this);
      }
    }
  }

  /***
   * 打开/关闭弹幕设置弹窗
   * val: 打开弹窗: true; 关闭：false, 不传值：自动（默认）
   */
  toggleDanmakuSettingPopup(val) {
    let popup;
    if (this.barrageSetting.popupContainer) {
      // 优先找自定义的面板容器
      popup = document.querySelector(this.barrageSetting.popupContainer);
    }
    if (!popup) {
      // 没有再找sdk默认的面板容器
      const _isMobile = isMobile();
      popup = _isMobile
        ? document.querySelector('.h5vhallPlayer_brarage_popup_Landscape')
        : document.querySelector('.vhallPlayer-brarage-popup');
    }
    if (popup) {
      if (typeof val === 'boolean') {
        popup.style.display = val ? 'block' : 'none';
      } else {
        popup.style.display = popup.style.display === 'block' ? 'none' : 'block';
      }
    }
  }

  /**
   * 设置seek限制（仅点播）
   * @param {object} opt 设置seek限制所需参数
   * @param {function} failure 失败回调
   */
  setLimitSeek(opt, failure) {
    if (this.isLive) {
      failure && failure({ code: '611004', message: '此方法仅点播可用', data: {} });
      return;
    }
    if (typeof opt !== 'object' && (!opt.hasOwnProperty('enable') || !opt.hasOwnProperty('maxTime'))) {
      failure && failure({ code: '611001', message: '无效的参数', data: {} });
      return;
    }
    if (typeof opt.enable !== 'boolean' || typeof opt.maxTime !== 'number') {
      failure && failure({ code: '611001', message: '无效的参数', data: {} });
      return;
    }

    this.isLimitSeek = opt.enable; // 是否开启seek限制
    this.limitSeekMax = opt.maxTime;
  }

  /**
   * 获取当前seek限制信息（仅点播）
   * @param {function} failure 失败回调
   */
  getLimitSeek(failure) {
    if (this.isLive) {
      failure && failure({ code: '611004', message: '此方法仅点播可用', data: {} });
      return;
    }
    return { enable: this.isLimitSeek, maxTime: this.limitSeekMax };
  }

  /**
   * 处理直播时移播放
   */
  handleTimeshiftPlay(opts, failure) {
    const { delay } = opts;
    if (delay < 0) {
      failure && failure({ code: '611001', message: '无效的参数', data: {} });
      return;
    }
    this.vhallplayer.handleTimeshiftPlay(opts);
  }

  /**
   * 重加载点播字幕
   */
  async reloadVodSubtitle() {
    try {
      const playerData = await this._api.initVod(this._originalOption.vodOption.recordId);
      this.vhallplayer.reloadVodSubtitle(playerData.subtitle_info);
    } catch (ex) {
      console.log('获取点播字幕信息失败', ex);
    }
  }

  /**
   * 开启点播字幕
   */
  openVodSubtitle(obj) {
    this.vhallplayer.openVodSubtitle(obj);
  }

  /**
   * 关闭点播字幕
   */
  closeVodSubtitle() {
    this.vhallplayer.closeVodSubtitle();
  }

  /**
   * 获取当前点播字幕信息
   */
  getCurrentVodSubtitle(failure) {
    if (this.isLive) {
      failure && failure({ code: '611004', message: '此方法仅点播可用', data: {} });
      return;
    }
    return this.vhallplayer.getCurrentVodSubtitle();
  }

  /**
   * 获取点播字幕列表
   */
  getVodSubtitleList(failure) {
    if (this.isLive) {
      failure && failure({ code: '611004', message: '此方法仅点播可用', data: {} });
      return;
    }
    return this.vhallplayer.getVodSubtitleList();
  }

  /**
   * 切换点播字幕
   */
  switchVodSubtitle(opt, failure) {
    if (this.isLive) {
      failure && failure({ code: '611004', message: '此方法仅点播可用', data: {} });
      return;
    }
    if (typeof opt !== 'object') {
      failure && failure({ code: '611001', message: '无效的参数', data: {} });
      return;
    }
    if (opt === this.getCurrentVodSubtitle()) {
      return;
    }
    this.vhallplayer.switchVodSubtitle(opt);
  }

  /** 更新点播字幕样式 */
  updateVodSubTitleStyle(key, val) {
    const videoDom = this.vhallplayer.getVideo();
    if (!videoDom) return;

    if (Object.prototype.toString.call(key) === '[object String]') {
      key = key.trim();
      if (key) {
        // 传单个key-value
        videoDom.style.setProperty(key.startsWith('--') ? key : `--${key}`, val);
      }
    } else if (Object.prototype.toString.call(key) === '[object Object]') {
      // 传key-value对象
      for (const k in key) {
        videoDom.style.setProperty(k.startsWith('--') ? k : `--${k}`, key[k]);
      }
    }
  }

  /**
   * 开启直播字幕
   * 适用于： 自研实时字幕、腾讯云MPS实时字幕、伪直播多语言字幕
   */
  openLiveSubtitle(failure) {
    if (!this.isLive) {
      return failure && failure({ code: '611003', message: '此方法仅直播可用', data: {} });
    }
    return this.vhallplayer.openLiveSubtitle(failure);
  }

  /**
   * 关闭直播字幕
   */
  closeLiveSubtitle(failure) {
    if (!this.isLive) {
      return failure && failure({ code: '611003', message: '此方法仅直播可用', data: {} });
    }
    return this.vhallplayer.closeLiveSubtitle(failure);
  }

  /**
   * 获取直播字幕类型列表
   */
  getLiveSubtitleList() {
    return this.vhallplayer.getLiveSubtitleList();
  }

  /**
   * 切换直播字幕类型
   */
  changeLiveSubtitle(value, failure) {
    return this.vhallplayer.changeLiveSubtitle(value, failure);
  }

  /**
   * 获取当前播放的字幕类型
   */
  getCurrentLiveSubtitleName() {
    return this.vhallplayer.currentSubtitleName;
  }

  /**
   * 修改跑马灯
   */
  editMarquee(opts = {}, failure = () => {}) {
    if (typeof opts !== 'object') {
      failure && failure({ code: '611001', message: '无效的参数', data: {} });
      return;
    }
    const { text, interval = 20 } = opts;
    if (!text || (text && text.length > 64)) {
      failure &&
        failure({
          code: '611001',
          message: '无效的参数',
          data: { detail: '跑马灯文本必填，且字数在64字以内' }
        });
      return;
    }

    // h5字体大小赋默认值
    if (opts.size && !opts.h5FontSize) {
      opts.h5FontSize = opts.size;
    }

    let unit = (isMobile() ? opts.h5Unit : opts.unit) || 'px';

    if (isMobile()) {
      if (unit === 'px' && (parseInt(opts.h5FontSize) < 1 || parseInt(opts.h5FontSize) > 200)) {
        failure &&
          failure({
            code: '611001',
            message: '无效的参数',
            data: { detail: '跑马灯字体大小范围在1到200之间' }
          });
        return;
      }
    } else {
      if (unit === 'px' && (parseInt(opts.size) < 1 || parseInt(opts.size) > 200)) {
        failure &&
          failure({
            code: '611001',
            message: '无效的参数',
            data: { detail: '跑马灯字体大小范围在1到200之间' }
          });
        return;
      }
    }

    if (parseInt(interval) < 0 || parseInt(interval) > 300) {
      failure &&
        failure({
          code: '611001',
          message: '无效的参数',
          data: { detail: '跑马灯时间间隔范围在0到300之间' }
        });
      return;
    }
    this.vhallplayer.editMarquee(opts);
  }

  /**
   * 进入画中画
   */
  requestPictureInPicture(opt) {
    return this.vhallplayer.requestPictureInPicture(opt);
  }
  /**
   * 退出画中画
   */
  exitPictureInPicture(opt) {
    return this.vhallplayer.exitPictureInPicture(opt);
  }

  // 以下，内部接口，未暴露至官方SDK文档
  // 以下，内部接口，未暴露至官方SDK文档
  // 以下，内部接口，未暴露至官方SDK文档
  /**
   * 缓存弹幕配置信息
   */
  saveSetting() {
    if (this.barrageSetting.useLocalCache) {
      // 只缓存部分设置信息
      const barrageSettingPart = {
        positionRange: this.barrageSetting.positionRange,
        speed: this.barrageSetting.speed,
        style: this.barrageSetting.style
      };
      localStorage.setItem(this.barrageSetting.localCacheKey, JSON.stringify(barrageSettingPart));
    }
  }

  /**
   * 获取播放器版本
   */
  getVersion() {
    return this.vhallplayer.version;
  }

  /**
   * 获取已下载大小
   */
  getDownloadSize() {
    return this.vhallplayer.getDownloadSize();
  }

  /**
   * 获取cdn名称
   */
  getCdnName() {
    return this.vhallplayer.getCdnName();
  }

  /**
   * 获取当前播放器的buffered
   */
  getBuffered() {
    return this.vhallplayer.getBuffered();
  }

  /**
   * 获取网络预估网速
   */
  getEstimateNetSpeed() {
    return this.vhallplayer.getEstimateNetSpeed();
  }

  /**
   * 重新设置大小
   * @param {object} opt 设置大小所需参数
   * @param {function} failure 失败回调
   */
  setSize(opt, failure) {
    const { width, height } = opt;
    if (
      !opt.hasOwnProperty('width') ||
      !opt.hasOwnProperty('height') ||
      typeof width !== 'number' ||
      typeof height !== 'number'
    ) {
      failure && failure({ code: '611001', message: '无效的参数', data: {} });
      return;
    }
    this.vhallplayer.setSize(width, height);
  }

  /**
   * 打开或关闭控制条
   * @param {boolean} boolean 开启或关闭控制条
   */
  openControls(boolean) {
    this.vhallplayer.setControls(boolean);
  }
}
